export const recentPurchases = [
  { name: 'Emily R.', city: 'Austin', country: 'United States', time: '2 minutes ago' },
  { name: 'Lucas M.', city: 'Madrid', country: 'Spain', time: '4 minutes ago' },
  { name: 'Sophie L.', city: 'Toronto', country: 'Canada', time: '7 minutes ago' },
  { name: 'Matteo B.', city: 'Milan', country: 'Italy', time: '10 minutes ago' },
  { name: 'Valentina G.', city: 'Buenos Aires', country: 'Argentina', time: '13 minutes ago' },
  { name: 'James T.', city: 'London', country: 'United Kingdom', time: '16 minutes ago' },
  { name: 'Camila S.', city: 'Mexico City', country: 'Mexico', time: '20 minutes ago' },
  { name: 'Noah W.', city: 'Sydney', country: 'Australia', time: '24 minutes ago' },
  { name: 'Hannah K.', city: 'Berlin', country: 'Germany', time: '29 minutes ago' },
]
